import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UploadStatus } from '../../../shared/models/upload-status';
import { UiStateStore } from '../../../shared/store/ui-state-store.service';
import { DataService } from '../../data.service';
import { JobApplication } from '../../models/job-application';
import { JobInfo } from '../../models/job-info';
import { JobsStore } from '../../store/jobs-store.service';

@Component({
  selector: 'apply-job',
  templateUrl: './apply-job.component.html',
  styleUrls: ['./apply-job.component.scss']
})
export class ApplyJobComponent implements OnInit {

  accountId: string;
  jobId: string | null;
  jobInfo: JobInfo;
  uploadStatus: string;
  fileName?: string;
  filePath: string;

  form: FormGroup;
  constructor(private formBuilder: FormBuilder,
    public uiState: UiStateStore,
    public jobStore: JobsStore,
    public dataService: DataService,
    public route: ActivatedRoute,
    public router: Router) {
  }

  ngOnInit() {

    this.route.paramMap.subscribe(paramMap => {
      this.jobId = paramMap.get("jobId");
    })

    this.uiState.authenticatedUser.subscribe(user => {
      if (!user) {
        return;
      }
      this.accountId = user.accountId;

      this.dataService.getProfile(this.accountId).subscribe(profile => {
        if (!profile) {
          return;
        }

        this.form.patchValue({ "name": profile.firstName });
        this.form.patchValue({ "phone": profile.phone });
        this.form.patchValue({ "email": profile.email });
        this.form.patchValue({ "title": profile.title });
        this.form.patchValue({ "salary": profile.salary });
      });

      this.dataService.getJobInfo(this.jobId).subscribe(jobInfo => {
        if(!jobInfo) {
          return;
        }

        this.jobInfo = jobInfo;
      });

    });

    this.form = this.formBuilder.group({
      accountId: [`${this.accountId}`],
      name: ['', Validators.required],
      phone: ['', [Validators.pattern("^\\+{0,1}[0-9]{11,14}$")]],
      email: ['', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
      jobTitle: [''],
      salary: ['', [Validators.pattern("^[0-9]+$")]],
      coverLetter: [''],
      cvPath: ['']
    });
  }

  apply(): void {
    if (!this.form.valid) {
      return;
    }

    let jobApplication = JobApplication.parse(this.form);
    jobApplication.jobId = this.jobId;
    jobApplication.cvPath = this.filePath;
    jobApplication.jobTitle = this.jobInfo.title;

    this.dataService.applyJob(jobApplication).subscribe(jobApp => {
      this.router.navigate(['search-jobs']);
    }, error => {
      this.router.navigate(['search-jobs']);
    });
  }

  uploadFinished(status: UploadStatus): void {
    this.uploadStatus = status.status;
    this.filePath = status.filePath;
    this.fileName = this.filePath.split("\\").pop();
    setTimeout(() => {
      this.uploadStatus = "";
    }, 1000);
  }

}
